import { render, staticRenderFns } from "./TitleDesctiptionTable.vue?vue&type=template&id=7bc680f1"
import script from "./TitleDesctiptionTable.vue?vue&type=script&lang=js"
export * from "./TitleDesctiptionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports